import { IStore } from '../app/models/settings.model';

const defaultStoreConfig: Partial<IStore> = {
  active: true,
  redirect: true,
  showPriceDisclaimer: false,
  hiddenStoreUserMenu: [],
  addOrderTypeToAdlytics: false,
  defaultPriceDivisorValue: 100,
  paginationSettingsPerFeature: {
    orders: {limitPerPage: 20},
    serviceOrders: {limitPerPage: 20},
    sparePartOrders: {limitPerPage: 20},
    purchaseActivity: {limitPerPage: 20},
  },
  defaultShipmentMethod: {
    name: '',
  },
};

export const environment = {
  defaultStore: 'BR',
  defaultLang: 'en',
  stores: [
    {
      ...defaultStoreConfig,
      marketCode: 'au',
      storeId: 'AU',
      storeDefaultCurrency: 'AUD',
      storeDefaultPriceMode: 'NET_MODE',
      paginationSettingsPerFeature: {
        orders: {limitPerPage: 50},
        serviceOrders: {limitPerPage: 50},
        sparePartOrders: {limitPerPage: 50},
        purchaseActivity: {limitPerPage: 50},
      },
      name: 'Australia',
      dateFormat: 'dd-MM-yyyy',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'en-AU',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
        {
          id: 'terms_and_conditions',
          lang: 'en',
          value: 'https://marketing.webassets.siemens-healthineers.com/e2ca3b6f2c0ec912/cb20fea682b7/20220517-shs-au-conditions-of-supply-and-installation.pdf',
        },
      ],
      address: {
        default: {
          companyName: 'Siemens Healthcare Pty Ltd',
          address1: 'Level 3, 141 Camberwell Rd, Hawthorn East, Victoria, 3123, Australia',
          emailAddress: 'shop.au.func@siemens-healthineers.com',
        },
      },
      deliveryAddressCountries: [
        {name: 'Australia', value: 'AU', isDefault: true},
      ],
      catalogFilters: [
        'mcm_webshop_anatomic_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_system_area_mapped',
        'sap_p40_modality_id_mapped',
      ],
    },
    {
      ...defaultStoreConfig,
      marketCode: 'br',
      storeId: 'BR',
      storeDefaultCurrency: 'BRL',
      storeDefaultPriceMode: 'GROSS_MODE',
      name: 'Brazil',
      dateFormat: 'dd/MM/yyyy',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'pt-BR',
          code: 'pt',
          name: 'Portuguese',
          defaultCurrencyLocale: 'pt',
        },
        {
          id: 'en-BR',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
        {
          id: 'privacy_policy',
          lang: 'pt',
          value: 'https://www.siemens-healthineers.com/br/siemens-website-privacy-policy',
        },
      ],
      address: {
        default: {
          companyName: 'Siemens Healthcare Diagnósticos Ltda',
          address1: 'CNPJ 01.449.930/0001-90 Av. Mutinga 3800,',
          address2: ' São Paulo – SP 05110-902',
          phoneNumber: '08000554838',
          emailAddress: 'shop.br@siemens-healthineers.com',
        },
      },
      deliveryAddressCountries: [
        {name: 'Brazil', value: 'BR', isDefault: true},
      ],
      catalogFilters: [
        'mcm_webshop_system_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_anatomic_area_mapped',
        'mcm_gg',
      ],
    },
    {
      ...defaultStoreConfig,
      marketCode: 'ca',
      storeId: 'CA',
      storeDefaultCurrency: 'CAD',
      storeDefaultPriceMode: 'GROSS_MODE',
      name: 'Canada',
      dateFormat: 'yyyy-MM-dd',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'en-CA',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
        {
          id: 'fr-CA',
          code: 'fr',
          name: 'French',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
        {
          id: 'privacy_policy',
          lang: 'fr',
          value: 'https://www.siemens-healthineers.com/fr-ca/siemens-website-privacy-policy',
        },
        {
          id: 'cookie_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/cookie',
        },
        {
          id: 'cookie_policy',
          lang: 'fr',
          value: 'https://www.siemens-healthineers.com/fr/cookie',
        },
      ],
      address: {
        default: {
          companyName: 'Siemens Healthcare Limited |',
          address1: '1577 North Service Road East, Oakville, ',
          address2: 'ON, L6H 0H6, ',
          address3: 'Canada',
          emailAddress: 'teamplayfleet.ca@siemens-healthineers.com',
          phoneNumberFormat: '3|3|4',
          prefix: '+1',
          delimiter: '-',
          needHelp: {
            questionsAboutParts: {
              phoneNumber: '8003596709',
              phoneNumberAdditionalInfo: '(press 2 for parts)',
              directSalesEmailAddress: 'customercarecentre.ca@siemens-healthineers.com',
            },
            websiteAndTechnicalSupport: {
              emailAddress: 'teamplayfleet.ca@siemens-healthineers.com',
            },
          },
        },
        fr: {
          companyName: 'Siemens Santé limitée |',
          address1: '1577 North Service Road East, Oakville, ',
          address2: 'ON, L6H 0H6, ',
          address3: 'Canada',
          emailAddress: 'teamplayfleet.ca@siemens-healthineers.com',
          phoneNumberFormat: '3|3|4',
          prefix: '+1',
          delimiter: '-',
          needHelp: {
            questionsAboutParts: {
              phoneNumber: '8003596709',
              phoneNumberAdditionalInfo: '(appuyez sur 2 pour les pièces)',
              directSalesEmailAddress: 'customercarecentre.ca@siemens-healthineers.com',
            },
            websiteAndTechnicalSupport: {
              emailAddress: 'teamplayfleet.ca@siemens-healthineers.com',
            },
          },
        },
      },
      deliveryAddressCountries: [
        {name: 'Canada', value: 'CA', isDefault: true},
      ],
      hiddenStoreUserMenu: [
        'my-orders',
      ],
      catalogFilters: [
        'mcm_webshop_anatomic_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_system_area_mapped',
        'sap_p40_modality_id_mapped',
      ],
      defaultShipmentMethod: {
        name: 'Standard Delivery / Livraison standard',
      },
    },
    {
      ...defaultStoreConfig,
      marketCode: 'gb',
      storeId: 'GB',
      storeDefaultCurrency: 'GBP',
      storeDefaultPriceMode: 'GROSS_MODE',
      name: 'Great Britain',
      dateFormat: 'dd/MM/yyyy',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'en-GB',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
      ],
      address: {
        default: {
          companyName: 'Siemens Healthcare Limited |',
          address1: 'Parkview, Watchmoor Park, Camberley, ',
          address2: 'GU15 3YL, United Kingdom',
          emailAddress: 'csquotations.gb@siemens-healthineers.com',
        },
      },
      deliveryAddressCountries: [
        {name: 'United Kingdom', value: 'GB', isDefault: true},
        {name: 'Ireland', value: 'IE'},
      ],
      showPriceDisclaimer: true,
      catalogFilters: [
        'mcm_webshop_system_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_anatomic_area_mapped',
        'mcm_gg',
      ],
    },
    {
      ...defaultStoreConfig,
      marketCode: 'in',
      storeId: 'IN',
      storeDefaultCurrency: 'INR',
      storeDefaultPriceMode: 'GROSS_MODE',
      name: 'India',
      dateFormat: 'dd/MM/yyyy',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'en-IN',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
      ],
      address: {
        default: {
          companyName: 'Siemens Healthcare Private Limited,',
          address1: '9th Floor North Tower, Godrej One, ',
          address2: 'Pirojshanagar, Off Eastern Express Highway, ',
          address3: 'Vikhroli East, Mumbai 400079, India',
          phoneNumber: '18002585828',
          phoneNumberFormat: '4|3|4',
          emailAddress: 'shop.in.func@siemens-healthineers.com',
        },
      },
      deliveryAddressCountries: [
        {name: 'India', value: 'IN', isDefault: true},
      ],
      addOrderTypeToAdlytics: true,
      catalogFilters: [
        'mcm_webshop_system_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_anatomic_area_mapped',
        'mcm_gg',
      ],
      emailGrievancesOfficer: 'contactshop.func.in@siemens-healthineers.com',
    },
    {
      ...defaultStoreConfig,
      marketCode: 'eu',
      storeId: 'EU',
      storeDefaultCurrency: 'EUR',
      storeDefaultPriceMode: 'NET_MODE',
      name: 'Europe',
      dateFormat: 'dd/MM/yyyy',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'en-EU',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
        {
          id: 'de-EU',
          code: 'de',
          name: 'German',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
      ],
      address: {
        default: {
          companyName: 'Siemens Healthineers AG,',
          address1: 'Siemensstr. 3, 91301 Forchheim Germany',
          emailAddress: 'teamplay.fleet@siemens-healthineers.com',
        },
        de: {
          companyName: 'Siemens Healthineers AG,',
          address1: 'Siemensstr. 3, 91301 Forchheim Deutschland',
          emailAddress: 'teamplay.fleet@siemens-healthineers.com',
        },
      },
      deliveryAddressCountries: [
        {name: 'Austria', value: 'AT'},
        {name: 'Belgium', value: 'BE'},
        {name: 'Bulgaria', value: 'BG'},
        {name: 'Cyprus', value: 'CY'},
        {name: 'Czechia', value: 'CZ'},
        {name: 'Germany', value: 'DE'},
        {name: 'Denmark', value: 'DK'},
        {name: 'Estonia', value: 'EE'},
        {name: 'Spain', value: 'ES'},
        {name: 'Finland', value: 'FI'},
        {name: 'France', value: 'FR'},
        {name: 'Greece', value: 'GR'},
        {name: 'Croatia', value: 'HR'},
        {name: 'Hungary', value: 'HU'},
        {name: 'Ireland', value: 'IE'},
        {name: 'Iceland', value: 'IS'},
        {name: 'Italy', value: 'IT'},
        {name: 'Liechtenstein', value: 'LI'},
        {name: 'Lithuania', value: 'LT'},
        {name: 'Luxembourg', value: 'LU'},
        {name: 'Latvia', value: 'LV'},
        {name: 'Malta', value: 'MT'},
        {name: 'Netherlands', value: 'NL'},
        {name: 'Norway', value: 'NO'},
        {name: 'Poland', value: 'PL'},
        {name: 'Portugal', value: 'PT'},
        {name: 'Romania', value: 'RO'},
        {name: 'Sweden', value: 'SE'},
        {name: 'Slovenia', value: 'SI'},
        {name: 'Slovakia', value: 'SK'},
      ],
      addOrderTypeToAdlytics: true,
      emailGrievancesOfficer: 'teamplay.fleet@siemens-healthineers.com',
      paginationSettingsPerFeature: {
        ...defaultStoreConfig.paginationSettingsPerFeature,
        orders: {limitPerPage: 1},
        serviceOrders: {limitPerPage: 1},
        sparePartOrders: {limitPerPage: 1},
      },
    },
    {
      ...defaultStoreConfig,
      marketCode: 'us',
      storeId: 'US',
      storeDefaultCurrency: 'USD',
      storeDefaultPriceMode: 'GROSS_MODE',
      name: 'United States',
      dateFormat: 'MM/dd/yyyy',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'en-US',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
      ],
      address: {
        default: {
          companyName: 'Siemens Medical Solutions USA, Inc. |',
          address1: '40 Liberty Boulevard, Malvern, ',
          address2: 'PA 19355, ',
          address3: 'USA',
          phoneNumber: '8335271090',
          emailAddress: 'shop.us@siemens-healthineers.com',
          phoneNumberFormat: '3|3|4',
          prefix: '+1',
          delimiter: '-',
          needHelp: {
            questionsAboutParts: {
              phoneNumber: '8008887436',
              directSalesEmailAddress: 'usccdirectsalessporders.team@siemens-healthineers.com',
              partsClarificationEmailAddress: 'cccpartsclarification.team@siemens-healthineers.com',
            },
            questionsAboutContracts: {
              phoneNumber: '8335271090',
              emailAddress: 'shop.us@siemens-healthineers.com',
            },
            websiteAndTechnicalSupport: {
              phoneNumber: '8335271090',
              emailAddress: 'shop.us@siemens-healthineers.com',
            },
          },
        },
      },
      deliveryAddressCountries: [
        {name: 'United States', value: 'US', isDefault: true},
      ],
      hiddenStoreUserMenu: [
        'my-orders',
      ],
      ecommerceTeamEmailAddress: 'shop.us@siemens-healthineers.com',
      catalogFilters: [
        'mcm_webshop_anatomic_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_system_area_mapped',
        'sap_p40_modality_id_mapped',
      ],
      defaultShipmentMethod: {
        name: 'FedEx Priority Overnight',
      },
      heavyweightShipmentMethod: {
        name: 'FedEx Heavy Weight Shipment',
      },
    },
    {
      ...defaultStoreConfig,
      marketCode: 'jp',
      storeId: 'JP',
      storeDefaultCurrency: 'JPY',
      storeDefaultPriceMode: 'NET_MODE',
      name: 'Japan',
      dateFormat: 'yyyy/MM/dd',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'ja-JP',
          code: 'ja',
          name: 'Japanese',
          defaultCurrencyLocale: 'ja',
        },
        {
          id: 'en-JP',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [],
      address: {
        default: {
          companyName: 'Siemens Healthcare K.K.',
          address1: '〒141-8644 東京都品川区大崎1丁目11番1号 ゲートシティ大崎ウエストタワー',
          emailAddress: 'webshop.jp@siemens-healthineers.com',
        },
      },
      deliveryAddressCountries: [
        {name: 'Japan', value: 'JP', isDefault: true},
      ],
      redirect: false,
      catalogFilters: [
        'mcm_webshop_anatomic_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_system_area_mapped',
        'mcm_gg',
      ],
      defaultPriceDivisorValue: 1,
    },
    {
      ...defaultStoreConfig,
      marketCode: 'dk',
      storeId: 'DK',
      storeDefaultCurrency: 'DKK',
      storeDefaultPriceMode: 'NET_MODE',
      name: 'Denmark',
      dateFormat: 'dd.MM.yyyy',
      timeFormat: 'HH:mm',
      languages: [
        {
          id: 'en-DK',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'da',
        },
      ],
      externalUrls: [],
      address: {
        default: {
          companyName: 'Siemens Healthcare A/S,',
          address1: 'Borupvang 9, 2750 Ballerup, ',
          address3: 'Denmark',
          emailAddress: 'oemparts.dk.team@siemens-healthineers.com',
          taxId: 'CVR: 88578228',
        },
      },
      deliveryAddressCountries: [
        {name: 'Denmark', value: 'DK', isDefault: true},
      ],
      hiddenStoreUserMenu: [
        'wishlists',
      ],
      addOrderTypeToAdlytics: true,
      catalogFilters: [
        'mcm_webshop_anatomic_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_system_area_mapped',
        'mcm_gg',
      ],
    },
    {
      ...defaultStoreConfig,
      marketCode: 'mea',
      storeId: 'MEA',
      storeDefaultCurrency: 'USD',
      storeDefaultPriceMode: 'NET_MODE',
      name: 'Middle East & Africa',
      dateFormat: 'DD/MM/YYYY',
      timeFormat: 'h:mm a',
      languages: [
        {
          id: 'en-MEA',
          code: 'en',
          name: 'English',
          defaultCurrencyLocale: 'en',
        },
        {
          id: 'fr-MEA',
          code: 'fr',
          name: 'French',
          defaultCurrencyLocale: 'en',
        },
      ],
      externalUrls: [
        {
          id: 'privacy_policy',
          lang: 'en',
          value: 'https://www.siemens-healthineers.com/siemens-website-privacy-policy',
        },
      ],
      address: {
        default: {
          companyName: 'TBD Siemens Healthineers Middle East & Africa |',
          address1: 'TBD Address 1, ',
          address3: 'TBD Address 3',
          emailAddress: 'TBD@siemens-healthineers.com',
        },
      },
      deliveryAddressCountries: [
        {name: 'United Arab Emirates', value: 'AE', isDefault: true},
      ],
      showPriceDisclaimer: true,
      catalogFilters: [
        'mcm_webshop_system_area_mapped',
        'mcm_webshop_clinical_field_mapped',
        'mcm_webshop_anatomic_area_mapped',
        'mcm_gg',
      ],
    },
  ] as IStore[],
};
